import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-green-800 mb-6">Politique de confidentialité</h1>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-orange-500 mb-3">Collecte des données personnelles</h2>
        <p className="mb-4">
          Lors de l&apos;utilisation du site, certaines données personnelles peuvent être collectées via les formulaires 
          (nom, prénom, email, téléphone, adresse postale, etc.).
        </p>
        <p>
          Ces données sont strictement nécessaires au traitement de votre demande et à l&apos;expédition des actes consulaires.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-orange-500 mb-3">Utilisation des données</h2>
        <p className="mb-4">
          Les données collectées sont utilisées uniquement par le Consulat Général de Côte d&apos;Ivoire à Paris 
          dans le cadre du traitement administratif de vos démarches.
        </p>
        <p>
          Aucune donnée personnelle n&apos;est cédée ou vendue à des tiers.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-orange-500 mb-3">Conservation des données</h2>
        <p>
          Les données sont conservées pendant la durée strictement nécessaire à leur traitement administratif, 
          conformément aux obligations légales et réglementaires.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-orange-500 mb-3">Paiement en ligne</h2>
        <p className="mb-4">
          Les paiements en ligne sont sécurisés et traités via une plateforme externe conforme aux normes PCI-DSS.
        </p>
        <p>
          Aucune donnée bancaire n&apos;est stockée sur le site.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-orange-500 mb-3">Droits des usagers</h2>
        <p className="mb-4">
          Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d&apos;un droit d&apos;accès, 
          de rectification, d&apos;effacement, et de limitation du traitement de vos données personnelles.
        </p>
        <p>
          Pour exercer ces droits, contactez : consulat.france@diplomatie.gouv.ci
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-orange-500 mb-3">Cookies</h2>
        <p>
          Des cookies techniques peuvent être utilisés pour améliorer l&apos;expérience utilisateur. 
          Aucun cookie de publicité ou de suivi marketing n&apos;est utilisé.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
